import http from '@/utils/http';

export default {
  async login(data) {
    return await http.post('/api/system_user/login', data);
  },
  async check() {
    return await http.get('/api/system_user/check');
  },
  async getCurrent() {
      return await http.get('/api/system_user/current');
  },
  async getById(id) {
    return await http.get(`/api/system_user/get/${id}`);
  },
  async insert(data) {
    return await http.post('/api/system_user/insert', data);
  },
  async update(data) {
    return await http.post('/api/system_user/update', data);
  },
  async delete(data) {
    return await http.post('/api/system_user/delete', data);
  }
};